<template>
  <div class="cloneContainer">
    <div class="clone">
      <img :src="clone.metadata.image" />
    </div>
    <div class="bottom">
      <p>{{ name }}</p>
    </div>
  </div>
</template>
<script>
import { computed } from 'vue';
export default {
  props: {
    clone: Object
  },

  setup(props) {
    const name = computed(() => {
      return props.clone.metadata.name;
    });
    return { name };
  }
};
</script>
<style scoped lang="scss">
.cloneContainer {
  height: 100%;
  border-radius: 10px;
  transition: all 100ms ease-in;
  &:hover {
    box-shadow: 0px 0px 15px #f277ad;
  }
  &:active {
    box-shadow: 0px 0px 25px #f277ad;
    transform: scale(0.97);
  }

  .clone {
    border-radius: 10px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    transition: all 100ms ease-in;
    cursor: pointer;
    flex: 1;
    border: 5px solid #f277ad;

    min-width: 250px;
    max-width: 300px;
    img {
      border-radius: 5px;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
      width: 100%;
      margin-bottom: -3px;
    }
  }

  .bottom {
    padding: 15px 10px;
    background-color: #f277ad;
    min-width: 250px;
    max-width: 300px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;

    p {
      font-size: 12px;
      word-break: break-all;
      width: 100%;
      font-size: 16px;
      color: white;
      font-weight: 700;
    }
  }
}
</style>
